import * as React from "react";

import RequestWithStore from "../components/RequestForm";

const FormPage = (props) => <RequestWithStore {...props} />;

export default FormPage;
